var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, cPointAtOrigin } from '@shapeable/utils';
import { animated, to } from '@react-spring/web';
import { useComponentProps } from '../context/component-props-context';
import { useSpringValues } from '../hooks/use-spring-values';
import { useStaticColors } from '../hooks/use-theme-colors';
var cls = classNames('svg-ring');
export var SvgRingDefaultProps = {
  radius: 50,
  strokeWidth: 10,
  startAngle: 0,
  endAngle: 360,
  colors: {
    stroke: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "])))
});
var PathStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var My = {
  NAME: 'SvgRing',
  Container: styled(animated.svg)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Path: styled(animated.path)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), PathStyles)
};
// -------- Component -------->
export var SvgRing = function (props) {
  var componentProps = useComponentProps(My.NAME, SvgRingDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    radius = componentProps.radius,
    startAngle = componentProps.startAngle,
    endAngle = componentProps.endAngle,
    cx = componentProps.cx,
    cy = componentProps.cy,
    strokeWidth = componentProps.strokeWidth,
    colors = componentProps.colors;
  var cPoint = cPointAtOrigin(cx, cy);
  var staticColors = useStaticColors(colors);
  // Compute the outer radius to account for the stroke being outside the radius
  var outerRadius = radius + strokeWidth / 2;
  var pathData = function (radius, startAngle, endAngle) {
    var startPoint = cPoint(outerRadius, startAngle);
    var endPoint = cPoint(outerRadius, endAngle);
    // Determine if the arc is greater than 180 degrees
    var largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;
    // Define the path for the arc
    return "\n      M ".concat(startPoint.cx, " ").concat(startPoint.cy, "\n      A ").concat(outerRadius, " ").concat(outerRadius, " 0 ").concat(largeArcFlag, " 1 ").concat(endPoint.cx, " ").concat(endPoint.cy, "\n    ");
  };
  var width = 2 * (outerRadius + strokeWidth / 2);
  var height = width;
  var values = useSpringValues(props);
  return React.createElement(My.Container, {
    className: cls.name(className),
    width: width,
    height: height,
    overflow: "visible",
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, React.createElement(My.Path, {
    fill: "none",
    stroke: staticColors.stroke,
    d: to([values.radius, values.startAngle, values.endAngle], pathData),
    colors: colors,
    strokeWidth: strokeWidth
  }));
};
SvgRing.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;